export default "__VITE_ASSET__ChysrYkL__"